import {CC_CONTRACT_DETAILS, CC_SURVEY_DETAILS} from '@cc-commons/cc-routing-roots';

export const CCDKBO_DASHBOARD = 'dashboard';
export const CCDKBO_CONTRACTS_LIST = 'contracts';
export const CCDKBO_CONTRACT_DETAILS = CC_CONTRACT_DETAILS;
export const CCDKBO_SURVEY_DETAILS = CC_SURVEY_DETAILS;
